import { Request } from '@features/requests/types';

/** Sorts a copy of the list by updatedAt descending (newest first). */
export function sortByUpdatedDesc(requests: Request[]): Request[] {
    return [...requests].sort(
        (a, b): number =>
            new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
    );
}

/** Sorts a copy of the list by startDate ascending (earliest first). */
export function sortByStartAsc(requests: Request[]): Request[] {
    return [...requests].sort((a, b): number => {
        if (!a.startDate && !b.startDate) return 0;
        if (!a.startDate) return 1;
        if (!b.startDate) return -1;
        return (
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        );
    });
}

/**
 * Sorts a copy of the list by deadline ascending (closest deadline first).
 * Requests without a deadline are placed at the end of the list.
 */
export function sortByDeadlineAsc(requests: Request[]): Request[] {
    return [...requests].sort((a, b): number => {
        if (!a.deadline && !b.deadline) {
            return 0;
        }
        if (!a.deadline) {
            return 1;
        }
        if (!b.deadline) {
            return -1;
        }
        return new Date(a.deadline).getTime() - new Date(b.deadline).getTime();
    });
}

/** Sorts a copy of the list by endDate descending (most recent first). */
export function sortByEndDesc(requests: Request[]): Request[] {
    return [...requests].sort((a, b): number => {
        if (!a.endDate && !b.endDate) return 0;
        if (!a.endDate) return 1;
        if (!b.endDate) return -1;
        return new Date(b.endDate).getTime() - new Date(a.endDate).getTime();
    });
}
